<template>
  <div class="rolesProfile">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1200px"
      :before-close="handleClose"
    >
      <el-form
        ref="formInline"
        size="small"
        label-width="100px"
        :model="formInline"
        inline
      >
        <el-form-item prop="roleName" label="角色名称">
          <el-input
            style="width: 200px"
            v-model="formInline.roleName"
            placeholder="请输入角色名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <div class="title">
        <el-button size="small" type="primary" @click="openHandleRoles('add')"
          >新增</el-button
        >
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="角色名称" width="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.roleName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色id" width="200" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.roleId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="150" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.status == 1">启用</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.roleDesc || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.updateTime || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="160" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="openHandleRoles('alter', row)"
              >编辑</span
            >
            <span class="blue_Box" @click="openPrivileges(row.roleId)"
              >分配权限</span
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-dialog>

    <!-- 新增、编辑角色 -->
    <HandleRoles ref="handleRolesRef" />
    <!-- 分配菜单 -->
    <Privileges ref="privilegesRef" />
  </div>
</template>

<script>
import { proxyRole, subProxyRole } from "@/api/organization";
import Privileges from "@/views/organization/components/privileges.vue";
import HandleRoles from "@/views/organization/components/handleRoles.vue";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  components: {
    myPagination,
    HandleRoles,
    Privileges,
  },
  data() {
    return {
      dialogTitle: "",
      dialogVisible: false,
      loading: false,
      data: [],
      formInline: {
        roleName: "",
      },
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      status: ""
    };
  },
  methods: {
    // 分配权限
    openPrivileges(roleId) {
      this.$refs.privilegesRef.init(this.status, roleId);
    },
    // 初始化
    init(status) {
      this.status = status;
      this.dialogTitle =
        status === "distribution" ? "分销商角色配置" : "代理商角色配置";
      this.getRoleList({ page: 1, limit: 10 });
      this.dialogVisible = true;
    },
    // 刷新
    refresh() {
      this.getRoleList(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    async getRoleList(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = this.status === 'agency' ? await proxyRole({ ...payload }) : await subProxyRole({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 新增、编辑角色
    openHandleRoles(status, payload) {
      this.$refs.handleRolesRef.init(status, this.status, payload);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getRoleList(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getRoleList({ page: 1, limit: 10 });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getRoleList(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getRoleList(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.rolesProfile {
  .title {
    margin-bottom: 10px;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>